const LandingHeroText = ({children, additionalclasses}) => {
    return (
        <p className={`poppins-bold text-[30px] lg:text-[50px] lg:leading-[72px] text-center text-white-50 ${additionalclasses}`}>
            {children}
        </p>
    );
}
export default LandingHeroText;